import { RateTableCarrier } from "./rate-table/rate-table-mapping";

export const shippingCarriers = [
  { name: "UPS", value: "UPS" },
  { name: "UPS SurePost", value: "UPSSurePost" },
  { name: "Canada Post", value: "CanadaPost" },
  { name: "Fed Ex Old", value: "FedExDefault" },
  { name: "Fed Ex", value: "FedEx" },
  { name: "Fed Ex Smart Post", value: "FedExSmartPost" },
  { name: "USPS Returns", value: "USPSReturns" },
  { name: "USPS", value: "USPS" },
  { name: "USPS Redo", value: "UspsShip" },
  { name: "AusPost", value: "AustraliaPost" },
  { name: "DHL", value: "DhlEcs" },
] as const;

export type ShippingCarrier = (typeof shippingCarriers)[number]["value"];

export const shippingCarrierToRateTableCarrier: Record<
  ShippingCarrier,
  RateTableCarrier
> = {
  UPS: RateTableCarrier.UPS,
  UPSSurePost: RateTableCarrier.UPS_SUREPOST,
  CanadaPost: RateTableCarrier.CANADA_POST,
  FedExDefault: RateTableCarrier.FEDEX,
  FedEx: RateTableCarrier.FEDEX,
  FedExSmartPost: RateTableCarrier.FEDEX,
  USPSReturns: RateTableCarrier.USPS,
  USPS: RateTableCarrier.USPS,
  UspsShip: RateTableCarrier.USPS,
  AustraliaPost: RateTableCarrier.AUSTRALIA_POST,
  DhlEcs: RateTableCarrier.DHL_ECS,
};
